import script from "./SchemaEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./SchemaEditor.vue?vue&type=script&setup=true&lang=js"

import "./SchemaEditor.vue?vue&type=style&index=0&id=1421e8a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1421e8a2"]])

export default __exports__